module.exports = __webpack_public_path__ + "img/panch_cuento_8_barco.626ab18c.png";